var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #005799;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.29,28.34c0,11.17-4.32,16.76-12.97,16.76-1.51,0-2.71-.13-3.59-.39v-2.79c1.04.34,2.23.51,3.55.51,3.12,0,5.48-.97,7.08-2.9,1.59-1.93,2.46-4.9,2.61-8.9h-.23c-.72,1.08-1.67,1.9-2.85,2.47-1.19.57-2.52.85-4,.85-2.53,0-4.53-.75-6.02-2.27s-2.23-3.62-2.23-6.33c0-2.97.83-5.31,2.49-7.03s3.84-2.58,6.55-2.58c1.94,0,3.63.5,5.09,1.49,1.45,1,2.57,2.45,3.35,4.36s1.17,4.16,1.17,6.75Zm-9.61-9.82c-1.86,0-3.3.6-4.32,1.8s-1.52,2.86-1.52,5c0,1.88.47,3.35,1.41,4.42s2.36,1.61,4.28,1.61c1.18,0,2.28-.24,3.27-.72s1.78-1.14,2.35-1.97c.57-.83.86-1.71.86-2.62,0-1.37-.27-2.63-.8-3.79-.54-1.16-1.28-2.07-2.24-2.73s-2.05-1-3.29-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN9);
export default __webpack_public_path__ + "static/media/n9.65d79cc168e5263d9eece3193132eec5.svg";
export { ForwardRef as ReactComponent };